import { useState, useEffect } from 'react'
import axios from 'axios'
import { FiUpload, FiEdit2, FiUsers, FiClipboard } from 'react-icons/fi'
import TmsSidebar from '../TmsComponents/TmsSidebar'
import TmsHeader from '../TmsComponents/TmsHeader'
import { useParams, useSubmit } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

export default function ViewEvent() {
  const [training, setTraining] = useState({
    title: '',
    description: '',
    start_date: '',
    duration_days: '',
    max_participants: 0,
    status: '',
  })
  const [enrolled, setEnrolled] = useState()
  const [signature, setSignature] = useState(null)
  const { training_id } = useParams()
  const navigate = useNavigate()
  // Fetch training details on component mount
  useEffect(() => {
    fetchTrainingDetails()
  }, [training_id])

  const fetchTrainingDetails = async () => {
    const token = localStorage.getItem('jwttoken')
    try {
      const response = await axios.get(
        `https://kaasbackend.vetrinahealthcare.com/tms/training/${training_id}/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      setTraining(response.data.training)
      console.log(response.data)
      setEnrolled(response.data.enrolled)
      // console.log("Fetched training details:", response.data);
    } catch (error) {
      console.error('Error fetching training details:', error)
    }
  }

  const handleUpdateTraining = async (field, value) => {
    const token = localStorage.getItem('jwttoken')
    try {
      await axios.put(
        `https://kaasbackend.vetrinahealthcare.com/tms/training/${training_id}/`,
        {
          [field]: value,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
          'Content-Type': 'application/json',
        }
      )
      fetchTrainingDetails()
    } catch (error) {
      console.error(`Error updating ${field}:`, error)
    }
  }

  const handleSignatureUpload = (e) => {
    const file = e.target.files?.[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setSignature(reader.result)
      }
      reader.readAsDataURL(file)
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#f0f4f8',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <TmsSidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <TmsHeader />
        <div className='rounded' style={{ width: '100%' }}>
          <div style={{ flex: 1 }}>
            <div
              style={{
                maxWidth: '1000px',
                margin: '20px auto',
                padding: '20px',
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              }}
            >
              <h1
                style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '16px',
                  color: '#4A5568',
                }}
              >
                Training Details
              </h1>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                }}
              >
                {/* Training Name */}
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
                >
                  <label
                    style={{
                      width: '120px',
                      fontWeight: '600',
                      color: '#718096',
                    }}
                  >
                    Training Name
                  </label>

                  <input
                    type='text'
                    style={{
                      flex: 1,
                      padding: '12px',
                      border: '1px solid #CBD5E0',
                      borderRadius: '4px',
                    }}
                    value={training.title}
                    onChange={(e) =>
                      setTraining({ ...training, title: e.target.value })
                    }
                  />

                  <button
                    style={{
                      padding: '10px 16px',
                      backgroundColor: '#38A169',
                      color: 'white',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      border: '0px',
                      transition: 'background-color 0.3s',
                    }}
                    onClick={() =>
                      handleUpdateTraining('title', training.title)
                    }
                  >
                    Update
                  </button>
                </div>

                {/* Description */}
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
                >
                  <label
                    style={{
                      width: '120px',
                      fontWeight: '600',
                      color: '#718096',
                    }}
                  >
                    Description
                  </label>
                  <input
                    type='text'
                    style={{
                      flex: 1,
                      padding: '12px',
                      border: '1px solid #CBD5E0',
                      borderRadius: '4px',
                    }}
                    value={training.description}
                    onChange={(e) =>
                      setTraining({ ...training, description: e.target.value })
                    }
                  />
                  <button
                    style={{
                      padding: '10px 16px',
                      backgroundColor: '#38A169',
                      color: 'white',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      border: '0px',
                      transition: 'background-color 0.3s',
                    }}
                    onClick={() =>
                      handleUpdateTraining('description', training.description)
                    }
                  >
                    Update
                  </button>
                </div>

                {/* Start Date */}
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
                >
                  <label
                    style={{
                      width: '120px',
                      fontWeight: '600',
                      color: '#718096',
                    }}
                  >
                    Start Date
                  </label>
                  <input
                    type='date'
                    style={{
                      flex: 1,
                      padding: '12px',
                      border: '1px solid #CBD5E0',
                      borderRadius: '4px',
                    }}
                    value={training.start_date}
                    onChange={(e) =>
                      setTraining({ ...training, start_date: e.target.value })
                    }
                  />
                  <button
                    style={{
                      padding: '10px 16px',
                      backgroundColor: '#38A169',
                      color: 'white',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      border: '0px',
                      transition: 'background-color 0.3s',
                    }}
                    onClick={() =>
                      handleUpdateTraining('start_date', training.start_date)
                    }
                  >
                    Update
                  </button>
                </div>

                {/* Duration */}
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
                >
                  <label
                    style={{
                      width: '120px',
                      fontWeight: '600',
                      color: '#718096',
                    }}
                  >
                    Duration (days)
                  </label>
                  <input
                    type='number'
                    style={{
                      flex: 1,
                      padding: '12px',
                      border: '1px solid #CBD5E0',
                      borderRadius: '4px',
                    }}
                    value={training.duration_days}
                    onChange={(e) =>
                      setTraining({
                        ...training,
                        duration_days: parseInt(e.target.value),
                      })
                    }
                  />
                  <button
                    style={{
                      padding: '10px 16px',
                      backgroundColor: '#38A169',
                      color: 'white',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      border: '0px',
                      transition: 'background-color 0.3s',
                    }}
                    onClick={() =>
                      handleUpdateTraining(
                        'duration_days',
                        training.duration_days
                      )
                    }
                  >
                    Update
                  </button>
                </div>

                {/* Signature Upload */}
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
                >
                  <label
                    style={{
                      width: '120px',
                      fontWeight: '600',
                      color: '#718096',
                    }}
                  >
                    Upload Signature
                  </label>
                  <div style={{ flex: 1 }}>
                    <label
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: '128px',
                        border: '2px dashed #CBD5E0',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        backgroundColor: '#F7FAFC',
                        transition: 'background-color 0.3s',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          paddingTop: '16px',
                          paddingBottom: '16px',
                        }}
                      >
                        <FiUpload
                          style={{
                            width: '32px',
                            height: '32px',
                            marginBottom: '8px',
                            color: '#A0AEC0',
                          }}
                        />
                        <p style={{ fontSize: '14px', color: '#A0AEC0' }}>
                          Click or drag to upload signature
                        </p>
                      </div>
                      <input
                        type='file'
                        style={{ display: 'none' }}
                        onChange={handleSignatureUpload}
                        accept='image/*'
                      />
                    </label>
                    {signature && (
                      <div style={{ marginTop: '16px' }}>
                        <img
                          src={signature}
                          alt='Signature'
                          style={{
                            maxHeight: '96px',
                            border: '1px solid #CBD5E0',
                            borderRadius: '4px',
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <button
                    style={{
                      padding: '10px 16px',
                      backgroundColor: '#3182CE',
                      color: 'white',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      border: '0px',
                      transition: 'background-color 0.3s',
                    }}
                  >
                    Save Signature
                  </button>
                </div>

                <div className='flex items-center gap-6'>
                  <label
                    style={{
                      width: '120px',
                      fontWeight: '600',
                      color: '#718096',
                    }}
                  >
                    No. Participant Added
                  </label>
                  <span className='text-gray-600 m-4'>{enrolled}</span>
                </div>

                {/* Participant Form */}
                <div className='flex items-center gap-6'>
                  <label
                    style={{
                      width: '120px',
                      fontWeight: '600',
                      color: '#718096',
                    }}
                  >
                    Participant Form
                  </label>
                  <button
                    onClick={() => navigate(`/selfregistration/${training_id}`)}
                    className='text-blue-600 hover:underline flex items-center gap-2'
                    style={{
                      border: '0px',
                      backgroundColor: 'transparent',
                      color: 'blue',
                      marginLeft: '10px',
                    }}
                  >
                    <FiEdit2 />
                    Click & copy from URL
                  </button>
                </div>

                {/* Participants */}
                <div className='flex items-center gap-6'>
                  <label
                    style={{
                      width: '120px',
                      fontWeight: '600',
                      color: '#718096',
                    }}
                  >
                    Participants
                  </label>
                  <button
                    className='text-blue-600 hover:underline flex items-center gap-2'
                    style={{
                      border: '0px',
                      backgroundColor: 'transparent',
                      color: 'blue',
                      marginLeft: '10px',
                    }}
                  >
                    <FiUsers />
                    View Participant
                  </button>
                </div>

                {/* Participants Feedback */}
                <div className='flex items-center gap-6'>
                  <label
                    style={{
                      width: '120px',
                      fontWeight: '600',
                      color: '#718096',
                    }}
                  >
                    Participants Feedback
                  </label>
                  <button
                    className='text-blue-600 hover:underline flex items-center gap-2'
                    style={{
                      border: '0px',
                      backgroundColor: 'transparent',
                      color: 'blue',
                      marginLeft: '10px',
                    }}
                  >
                    <FiClipboard />
                    View Participants Feedback
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
